module.exports = __webpack_public_path__ + "img/team-goals.3c6c30c7.svg";